import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";

export default defineNuxtPlugin((nuxtApp) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000 * 5, // 5 minutes
      },
    },
  });

  nuxtApp.vueApp.use(VueQueryPlugin, { queryClient, enableDevtoolsV6Plugin: true });

  return {
    // Exposed so code without an active component instance (e.g. route middleware) can
    // still read from/write to the same cache as useQuery()/useMutation() calls.
    provide: { queryClient },
  };
});
